import request from "@/utils/request.js";


export async function getAppConfig(params) {
  return request({
    url: "/api/public/event/registration/config/app",
    method: "get",
    params,
  });
}

export async function getThemeConfig(params) {
  return request({
    url: "/api/public/event/registration/config/theme",
    method: "get",
    params,
  });
}



export async function getConfig(params) {
  return request({
    url: "/api/public/event/registration/config",
    method: "get",
    params,
  });
}


export async function getSteps(params) {
  return request({
    url: "/api/public/event/registration/config/steps",
    method: "get",
    params,
  });
}


export async function getPageConfig(page, params) {
  return request({
    url: `/api/public/event/registration/config/page/${page}`,
    method: "get",
    params,
  });
}



export async function getOSSSTS(params) {
  return request({
    url: '/api/public/event/registration/config/oss/sts',
    method: 'post',
    params,
  })
}



export async function getWXJSSdkConfig(params) {
  return request({
    url: `/api/config/wxjssdk`,
    method: "get",
    params,
  });
}